import { PromoResponse } from '@/context/promo/types'
import { UrgencyVelocityResponse } from '@/context/urgency-velocity/types'
import { ProductionDetail } from '@/types/app-types'

import type { PriceFilterState, ProductionFilterState } from './components/context/types'

export enum SortType {
    instantDelivery = 'instantDelivery',
    superSeller = 'superSeller',
    greatDeal = 'greatDeal',
}

export type ProductionFilterStateLocalStorage = {
    [key: number]: Omit<ProductionFilterState, 'priceFilterState'> & {
        priceFilterState: Partial<PriceFilterState>
    }
}

export const PRODUCTION_FILTER_LOCALSTORAGE_KEY = 'productionFilterState'

export type ProductionPageSsrRequestsType = [
    Promise<ProductionDetail>,
    Promise<UrgencyVelocityResponse>,
    Promise<PromoResponse | undefined>,
]
